import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.promql = bracketIndenting({
	line: "#",
})
